class LangflowApiService {


  async getKtmbDelay(hours = 48, limit = 30) {
    try {
      const response = await fetch(`${process.env.REACT_APP_LANGFLOW_DOMAIN}/api/delays?limit=${limit}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching KTMB delay:', error);
      return null;
    }
  }
  async getKtmbDelayInfo(sessionId, flowId) {
    try {
      const data = await this.sendMessage("Any Ktmb Delay", sessionId, flowId);
      // Try to extract a useful message
      let info = data?.text || data?.outputs?.[0]?.outputs?.[0]?.results?.message?.text || JSON.stringify(data);
      return info;
    } catch (err) {
      return null;
    }
  }

  async sendMessage(text, sessionId, flowId) {
    if (flowId == null) {
      flowId = process.env.REACT_APP_LANGFLOW_MAIN_FLOW_ID;
    }
    const payload = {
      input_value: text,
      output_type: 'chat',
      input_type: 'chat',
      session_id: sessionId
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_LANGFLOW_DOMAIN}/api/v1/run/${flowId}}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_LANGFLOW_API_KEY
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  }



  // Function to recursively search for a block with specific type and name
  findToolUseBlock(obj, toolName) {
    if (Array.isArray(obj)) {
      for (const item of obj) {
        const found = this.findToolUseBlock(item, toolName);
        if (found) return found;
      }
    } else if (typeof obj === 'object' && obj !== null) {
      if (obj.type === "tool_use" && obj.name === toolName) {
        return obj;
      }

      for (const key in obj) {
        const found = this.findToolUseBlock(obj[key], toolName);
        if (found) return found;
      }
    }
    return null;
  }

  getDisplayText2(data) {
    try {
      const outputs = data?.outputs;
      if (!outputs || outputs.length === 0) return "No outputs found.";
  
      const lastOutput = outputs[outputs.length - 1];
      const nestedOutputs = lastOutput?.outputs;
      if (!nestedOutputs || nestedOutputs.length === 0) return "No nested outputs found.";
  
      const lastNested = nestedOutputs[nestedOutputs.length - 1];
      const message = lastNested?.results?.message?.text;
  
      return message || "No text message found.";
    } catch (error) {
      return `Error extracting message: ${error.message}`;
    }
  }

  getDisplayText(data) {
    try {
      const allOutputBlocks = data?.outputs;
      if (!allOutputBlocks || allOutputBlocks.length === 0) return "No outputs found.";
  
      let finalLLMText = null;
      let googleAIText = null;
      let fallbackText = null;
  
      for (const outputBlock of allOutputBlocks) {
        const nestedOutputs = outputBlock?.outputs;
        if (!nestedOutputs || nestedOutputs.length === 0) continue;
  
        for (const nestedOutput of nestedOutputs) {
          const message = nestedOutput?.results?.message;
          const text = message?.text;
          const sourceDisplayName = message?.properties?.source?.display_name;
          
          if (text && typeof text === 'string') {
            // Filter out invalid JSON-like strings and technical outputs
            const trimmedText = text.trim();
            if (
              trimmedText !== "" &&
              !trimmedText.startsWith("{") &&
              !trimmedText.startsWith("[") &&
              trimmedText.length > 10 // Avoid very short technical messages
            ) {
              if (sourceDisplayName === 'final LLM') {
                finalLLMText = text;
                break; // Found the final LLM message, no need to continue
              } else if (sourceDisplayName === 'Google Generative AI') {
                googleAIText = text; // Keep the latest Google AI message
              } else {
                // Store any other valid message as a fallback
                fallbackText = text;
              }
            }
          }
        }
        
        if (finalLLMText) break; // Found the final LLM message, no need to continue
      }
  
      // Return the first available message in order of priority
      return finalLLMText || googleAIText || fallbackText || "No message text found.";
    } catch (error) {
      return `Error extracting display text: ${error.message}`;
    }
  }

  parseResponse(data) {

    let travelFrom = null;
    let travelTo = null;

    let text = this.getDisplayText(data);
    console.log("parseResponse text ", text);
    let ktmbTimetable = null;
    let departureTime = null;
    let travelOptions = null;
    let travelBlock = this.findToolUseBlock(data, "get_travel_options");
    if (travelBlock) {
      const rawOptions = travelBlock.output?.value;
      // Ensure travelOptions is always an array or null
      if (Array.isArray(rawOptions)) {
        travelOptions = rawOptions;
      } else if (rawOptions && typeof rawOptions === 'object') {
        // If it's a single object, wrap it in an array
        travelOptions = [rawOptions];
      } else {
        console.warn('[LangflowApiService] Invalid travelOptions format:', rawOptions);
        travelOptions = null;
      }
      travelFrom = travelBlock.tool_input.input_value.split('|')[0];
      travelTo = travelBlock.tool_input.input_value.split('|')[1];
      // text = travelBlock.output.value;
    }

    let trainScheduleBlock = this.findToolUseBlock(data, "get_train_schedule");

    if (trainScheduleBlock) {
      const timetableBlock = trainScheduleBlock.output?.value ?? null;

      // If API returned a simple string (e.g. an error like "API error: 500 ..."),
      // surface that text directly back to the user so they know what went wrong.
      // if (typeof timetableBlock === 'string') {
      // text = timetableBlock;
      if (timetableBlock && typeof timetableBlock === 'object') {
        // If the block contains an explicit error field, surface that
        // if (timetableBlock.error || timetableBlock.message) {
        //   text = timetableBlock.error || timetableBlock.message;
        // }
        // Extract useful structured data when the response is an object
        travelFrom = timetableBlock?.from_station;
        travelTo = timetableBlock?.to_station;

        // Handle the actual JSON structure from KTMB API
        if (timetableBlock?.timetableList) {
          // If it's already an array, use it directly
          if (Array.isArray(timetableBlock.timetableList)) {
            ktmbTimetable = timetableBlock.timetableList;
          } else {
            // If it's a single object, wrap it in an array
            ktmbTimetable = [timetableBlock.timetableList];
          }
        }

        departureTime = timetableBlock?.departDate;
      }
    }

    // If we have text that contains JSON-like structure, try to parse it
    // if (!ktmbTimetable && text) {
    //   try {
    //     // Look for JSON-like patterns in the text
    //     const jsonMatch = text.match(/\{[\s\S]*\}/);
    //     if (jsonMatch) {
    //       const parsed = JSON.parse(jsonMatch[0]);
    //       if (parsed.arrivalTime || parsed.departTime || parsed.trainNo) {
    //         ktmbTimetable = [parsed];
    //       }
    //     }
    //   } catch (e) {
    //     console.log("Could not parse JSON from text:", e);
    //   }
    // }

    return {
      text,
      travelFrom,
      travelTo,
      travelOptions,
      ktmbTimetable,
      departureTime
    };
  }
}

export default new LangflowApiService(); 